var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3332V9.99984M10 6.6665H10.0084M1.66669 7.10212V12.8976C1.66669 13.1014 1.66669 13.2033 1.68971 13.2992C1.71013 13.3842 1.7438 13.4655 1.78949 13.5401C1.84102 13.6242 1.91308 13.6962 2.05721 13.8404L6.1595 17.9426C6.30362 18.0868 6.37569 18.1588 6.45978 18.2104C6.53434 18.2561 6.61563 18.2897 6.70066 18.3101C6.79657 18.3332 6.89848 18.3332 7.10231 18.3332H12.8977C13.1016 18.3332 13.2035 18.3332 13.2994 18.3101C13.3844 18.2897 13.4657 18.2561 13.5403 18.2104C13.6244 18.1588 13.6964 18.0868 13.8405 17.9426L17.9428 13.8404C18.087 13.6962 18.159 13.6242 18.2106 13.5401C18.2562 13.4655 18.2899 13.3842 18.3103 13.2992C18.3334 13.2033 18.3334 13.1014 18.3334 12.8976V7.10212C18.3334 6.8983 18.3334 6.79638 18.3103 6.70048C18.2899 6.61545 18.2562 6.53416 18.2106 6.4596C18.159 6.3755 18.087 6.30344 17.9428 6.15931L13.8405 2.05703C13.6964 1.9129 13.6244 1.84084 13.5403 1.7893C13.4657 1.74361 13.3844 1.70994 13.2994 1.68953C13.2035 1.6665 13.1016 1.6665 12.8977 1.6665H7.10231C6.89848 1.6665 6.79657 1.6665 6.70066 1.68953C6.61563 1.70994 6.53434 1.74361 6.45978 1.7893C6.37569 1.84084 6.30362 1.9129 6.1595 2.05703L2.05721 6.15931C1.91308 6.30344 1.84102 6.3755 1.78949 6.4596C1.7438 6.53416 1.71013 6.61545 1.68971 6.70048C1.66669 6.79638 1.66669 6.8983 1.66669 7.10212Z",
    stroke: "#F4B52D",
    strokeWidth: 1.91304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIYellow);
export default __webpack_public_path__ + "static/media/i-yellow.f91f89d17426a6a3a52fa0ff6748f509.svg";
export { ForwardRef as ReactComponent };